import { Skeleton } from '@/components/ui/Skeleton';
import { cn } from '@/lib/utils';

export interface LaudoSkeletonProps {
  /** Número de parágrafos no corpo. Default 6. */
  paragraphs?: number;
  className?: string;
}

/**
 * Skeleton de página de laudo: sumário lateral + corpo doc com N parágrafos.
 */
export function LaudoSkeleton({ paragraphs = 6, className }: LaudoSkeletonProps) {
  return (
    <div
      data-testid="laudo-skeleton"
      className={cn('grid gap-6 lg:grid-cols-[14rem_minmax(0,1fr)]', className)}
    >
      {/* Sumário lateral */}
      <div className="flex flex-col gap-2" data-testid="laudo-skeleton-summary">
        <Skeleton className="h-5 w-3/4" />
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>
      {/* Corpo do documento */}
      <div className="flex flex-col gap-4" data-testid="laudo-skeleton-body">
        <Skeleton className="h-9 w-2/3" />
        <Skeleton className="h-4 w-1/3" />
        {Array.from({ length: paragraphs }).map((_, i) => (
          <div key={i} className="flex flex-col gap-2" data-testid="laudo-skeleton-paragraph">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-11/12" />
            <Skeleton className="h-3.5 w-10/12" />
          </div>
        ))}
      </div>
    </div>
  );
}
